import { render, staticRenderFns } from "./screeningResult.vue?vue&type=template&id=829ba818&scoped=true&"
import script from "./screeningResult.vue?vue&type=script&lang=js&"
export * from "./screeningResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829ba818",
  null
  
)

export default component.exports